import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ user, onLogout }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const isActive = (path) => location.pathname === path;
  const close = () => setOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="nav-brand">
          <img src="/logo.svg" alt="DynaView" />
        </div>

        <button
          className="nav-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? '\u2715' : '\u2630'}
        </button>

        <div className={`nav-links ${open ? 'open' : ''}`}>
          <Link to="/" onClick={close} className={isActive('/') ? 'active' : ''}>Dashboard</Link>
          <Link to="/screens" onClick={close} className={isActive('/screens') ? 'active' : ''}>Écrans</Link>
          <Link to="/groups" onClick={close} className={isActive('/groups') ? 'active' : ''}>Groupes</Link>
          <Link to="/display-pages" onClick={close} className={isActive('/display-pages') ? 'active' : ''}>Affichage</Link>

          <Link to="/schedules" onClick={close} className={isActive('/schedules') ? 'active' : ''}>Horaires</Link>
          {user.role === 'admin' && (
            <Link to="/users" onClick={close} className={isActive('/users') ? 'active' : ''}>Utilisateurs</Link>
          )}
          <button onClick={() => { close(); onLogout(); }} className="nav-logout-link">Déconnexion</button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
